import React from 'react';

import { Box } from '@mui/material';

import { ReactComponent as ArrowRightIcon } from '../../../../../../public/images/ek/joystick/arrow-right.svg';
import { ReactComponent as ArrowLeftIcon } from '../../../../../../public/images/ek/joystick/arrow-left.svg';

import { INavigationWrapper } from './interfaces';

import { useStyles } from './styles';

const NavigationWrapper = ({ children, sx = {} }: INavigationWrapper) => {
  const classes = useStyles();
  const prevBtnClass = { ...classes.prevBtn, ...sx };
  const nextBtnClass = { ...classes.nextBtn, ...sx };

  return (
    <>
      <Box className="swiper-button-prev" sx={prevBtnClass}>
        <ArrowLeftIcon />
      </Box>
      {children}
      <Box className="swiper-button-next" sx={nextBtnClass}>
        <ArrowRightIcon />
      </Box>
    </>
  );
};

export default NavigationWrapper;
